import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Componente que força o scroll para o topo sempre que a rota mudar
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll imediato para o topo sempre que a rota mudar
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
